import {IEvent} from '@/features/labeling'
import {IPlotData} from '@/utils/media'
import {askSource} from './ask'
import {catalogSource} from './catalog'
import {localFileSource} from './local-file'
import {similarTitlesSource} from './similar-titles'
import {expressionSource} from './expression'

export interface IDataSourceItemMap {
  [id: string]: IDataSourceItem
}

export interface IDataSourceItem {
  _id: string
  catalog?: string
  ident?: string
  type?: string
  hidden?: boolean
  title?: string
  year?: number
  series_id?: string
  // backdrops?: IImageDescription[],
  // _append?: IMediaItem[],
  _file?: {
    name: string
    line: number
  }
  predictions?: IEvent[]
  fps?: number
  duration?: number
  plots?: {
    [name: string]: IPlotData
  }
  [key: string]: any
}

export interface IDataSource<TArgs = any> {
  sourceID: keyof typeof DataSourceTemplates
  key: string
  args: TArgs
  fetch: () => Promise<{[key: string]: IDataSourceItem} | undefined>
}

export const DataSourceTemplates = {
  ask: (args: Parameters<typeof askSource>[0]) => askSource(args),
  catalog: (args: Parameters<typeof catalogSource>[0]) => catalogSource(args),
  localFile: (args: Parameters<typeof localFileSource>[0]) => localFileSource(args),
  similar: (args: Parameters<typeof similarTitlesSource>[0]) => similarTitlesSource(args),
  expression: (args: Parameters<typeof expressionSource>[0]) => expressionSource(args),
}

export type DataSourceID = keyof typeof DataSourceTemplates
